import { object, string, array, boolean } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { a as INCORRECT_EMAIL_MESSAGE, E as EMAIL_REQUIRED_MESSAGE, O as OPTION_MESSAGE } from '../../../validation-g1IuPS7K.js';

const initialValues = {
    email: '',
    checkboxes: [false, false, false],
};

const initialValuesNoCheckboxes = {
    email: '',
    checkboxes: [true, false, false],
};

const validationSchema = object().shape({
    email: string().email(INCORRECT_EMAIL_MESSAGE).required(EMAIL_REQUIRED_MESSAGE),
    checkboxes: array()
        .of(boolean())
        .test('myCustomTest', (obj, context) => {
        if (obj.some(Boolean)) {
            return true;
        }
        return context.createError({
            message: OPTION_MESSAGE,
        });
    }),
});
var validationSchema$1 = yupResolver(validationSchema);

export { initialValues, initialValuesNoCheckboxes, validationSchema$1 as validationSchema };
//# sourceMappingURL=index.js.map
